<template>
  <v-container>
    <v-select v-model="hour" :items="timeOptions" dense solo></v-select>
  </v-container>
</template>

<script>
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

import lodashDebounce from "lodash/debounce";
import { mapGetters } from "vuex";
import { MODULE_PREFIX_MAP } from "@/store";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "TravelTrackerTimeSelector",
  props: {
    selected: {
      type: Number,
    },
  },
  data() {
    return {
      hour: dayjs().hour(),
    };
  },
  computed: {
    ...mapGetters({
      resetMapIcons: MODULE_PREFIX_MAP + "resetMapIcons",
    }),
    timeOptions() {
      return Array.apply(null, new Array(24)).map(function (x, i) {
        let listHour = i % 12 == 0 ? 12 : i % 12;
        return `${listHour}:00 ${i < 12 ? "am" : "pm"}`;
      });
    },
  },
  mounted() {
    this.handleValueChange();
  },
  methods: {
    handleValueChange() {
      if (this.selected) {
        this.hour = this.timeOptions[this.selected];
      }
    },
    emitValueDebounced: lodashDebounce(async function () {
      this.$emit(EMITTED_ACTIONS.CHANGE, this.timeOptions.indexOf(this.hour));
    }, 500),
  },
  watch: {
    selected: {
      handler() {
        this.value = this.selected;
      },
    },
    hour: {
      handler() {
        this.emitValueDebounced();
      },
    },
    resetMapIcons: {
      handler(newValue, oldValue) {
        if (oldValue !== newValue) {
          const hour = new Date().getHours();
          this.hour = this.timeOptions[hour];
          this.$emit(EMITTED_ACTIONS.CHANGE, this.timeOptions.indexOf(hour));
        }
      },
    },
  },
};
</script>

<style scoped>
.hyp_slider >>> .v-slider__tick-label {
  font-size: 12px !important;
}
</style>
